import React, { useContext, forwardRef } from 'react';
import classNames from 'classnames';
import { Context } from '../../context/AppContext';
import './styles.css';

const LayoutContainer = forwardRef(
  ({ children, type, flex = 'flex', ...props }, ref) => {
    const {
      media: { mobile },
    } = useContext(Context);
    return (
      <div
        {...props}
        ref={ref}
        className={classNames('LayoutContainer__root', {
          'LayoutContainer__root--mobile': mobile,
          [`LayoutContainer__root--${type}`]: type,
          [`LayoutContainer__root--${flex}`]: flex,
          [props.className]: props.className,
        })}
      >
        {children}
      </div>
    );
  }
);

export default LayoutContainer;
